import { Button, ButtonProps } from "antd";

const ButtonSimple = (props: ButtonProps) => {

  const {
    children,
    className,
    ...rest
  } = props;

  return (
    <Button
      className={`w-full rounded-md !hover:outline-none !hover:border-0 border-0 shadow-none focus:outline-none !focus:outline-none !focus:border-none disabled:opacity-60 hover:shadow-lg hover:shadow-blue-100 transition-all duration-300 !inline-flex !items-center !justify-center gap-2 [&_.ant-btn-loading-icon]:!inline-flex [&_.ant-btn-loading-icon]:!items-center [&_.ant-btn-loading-icon]:!justify-center [&_.ant-btn-loading-icon_.anticon]:!leading-none ${className}`}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default ButtonSimple;

// !bg-[#4a5568] !hover:bg-[#2d3748] font-semibold !hover:text-white !text-white !focus:text-white